import React, { useState, useEffect, useRef } from 'react';
import './Hero.css';
// Use optimized hero images from public/hero to allow preload and better caching

const Hero = () => {
  const [isTyping, setIsTyping] = useState(false);
  const [currentService, setCurrentService] = useState(0);
  const titleRef = useRef(null);
  
  // Removed unused variables to fix ESLint errors

  const services = [
    'Automotive Powder Coating',
    'Architectural Powder Coating', 
    'Industrial Powder Coating',
    'Custom Finishes',
    'Fabrication Services'
  ];

  useEffect(() => {
    // Typing effect for title
    const title = "Welcome to Glitter Metal Coating and Fabrication L.L.C";
    let index = 0;
    setIsTyping(true);

    const typeWriter = () => {
      if (index < title.length) {
        if (titleRef.current) {
          titleRef.current.textContent = title.substring(0, index + 1);
        }
        index++;
        setTimeout(typeWriter, 100);
      } else {
        setIsTyping(false);
      }
    };

    setTimeout(typeWriter, 1000);
  }, []);

  useEffect(() => {
    // Rotating services
    const interval = setInterval(() => {
      setCurrentService((prev) => (prev + 1) % services.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [services.length]);

  // Removed unused scrollToSection function to fix ESLint errors

  return (
    <section id="home" className="hero">
      <div className="hero-background-image">
        <picture>
          <source type="image/avif" srcSet="/hero/hero-480.avif 480w, /hero/hero-768.avif 768w, /hero/hero-1024.avif 1024w, /hero/hero-1600.avif 1600w" sizes="100vw" />
          <source type="image/webp" srcSet="/hero/hero-480.webp 480w, /hero/hero-768.webp 768w, /hero/hero-1024.webp 1024w, /hero/hero-1600.webp 1600w" sizes="100vw" />
          <img 
            src="/hero/hero-1024.webp" 
            alt="Glitter Metal Coating Hero" 
            className="hero-image"
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />
        </picture>
      </div>
      <div className="hero-overlay"></div>
      
      <div className="hero-container" style={{ paddingTop: '2%' }}>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span ref={titleRef} className={isTyping ? 'typing' : ''} style={{ color: 'var(--primary-beige)' }}></span>
              <span className="highlight">Your Trusted Partner</span>
            </h1>
            
            <div className="hero-subtitle-container">
              <p className="hero-subtitle" style={{ color: 'var(--primary-beige)', fontWeight: '800' }}>
                Your trusted partner for high-quality fabrications and powder coating solutions. With fresh energy and commitment to excellence, we deliver durable, visually appealing finishes for a wide range of applications. Whether you're seeking enhanced performance, lasting protection, or standout aesthetics, we're here to help your products shine and last.
              </p>
              <div className="rotating-service">
                <span className="service-label" style={{ color: 'var(--primary-beige)', fontStyle: 'italic' }}>Specializing in:</span>
                <span className="service-text" style={{ color: 'var(--primary-beige)' }}>{services[currentService]}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <span className="scroll-text">Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero; 